import { Dispatch, SetStateAction } from 'react';
import { MenuPagesProps } from '../types';

export enum PageMetadataTab {
  DEFAULT = 'default',
  METADATA = 'metadata',
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
}

export type PagesOptionProps = {
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
} & Required<Pick<MenuPagesProps, 'enableEmpty' | 'enableDelete'>>;

export type PagesOptionSettingProps = {
  setOpen: Dispatch<SetStateAction<boolean>>;
  setMetadataTab: Dispatch<SetStateAction<PageMetadataTab>>;
  upgradeRequired: boolean;
} & Required<Pick<MenuPagesProps, 'enableEmpty' | 'enableDelete'>>;

export type PagesOptionMetadataProps = {
  metadataOpen: boolean;
  setMetadataOpen: Dispatch<SetStateAction<boolean>>;
  metadataTab: PageMetadataTab;
  upgradeRequired: boolean;
  onMetadataChange: (changed: boolean) => void;
  imageChangeStatus: boolean;
  setImageChangeStatus: Dispatch<SetStateAction<boolean>>;
};

export type PagesOptionSEOSettingsProps = {
  columns: boolean;
  disabled: boolean;
};

export type PagesOptionFacebookProps = {
  columns: boolean;
  disabled: boolean;
  onRemoveCard?: () => void;
};

export type PagesOptionTwitterProps = {
  columns: boolean;
  disabled: boolean;
  onRemoveCard?: () => void;
};
